const colors = {
  'color-initial': '#fff',
  'color-initial-dark': '#000',
  // 'color-initial-special': '#46645a',
  'color-initial-special': '#565F62',

  'color-primary-light': '#46c882',
  'color-primary': '#3cb478',
  'color-primary-dark': '#328c64',

  'color-secondary-light': '#474747',
  'color-secondary-light2': '#BEBEBE',
  'color-secondary-light3': '#dfdfdf',
  'color-secondary': '#474747',
  'color-secondary-dark': '#000000',

  'color-tertiary-light': '#185673',
  'color-tertiary': '#163348',
  'color-tertiary-dark': '#0e2434',

  'color-quaternary-light': '#9facb5',
  'color-quaternary-light2': '#c3cfd7',
  'color-quaternary': '#4e7891',
  'color-quaternary-dark': '#375364',

  'color-quinary-light': '#f1f1f1',
  'color-quinary-light2': '#f8f8f8',
  'color-quinary': '#e7e7e7',
  'color-quinary-dark': '#909ca5',

  'color-quinary-special': '#cdcdcd',

  'color-senary': '#c4cbd1',

  'color-error': '#c80000',
  'color-error-background': '#CC0000',

  'color-warning': '#F57F17',
  'color-warning-background': '#F57F17',

  'color-success': '#3D9D20',

  'color-info': '#046489',
  'color-info-background': '#046489',

  'color-valid': '#6EBE64',
  'color-valid-background': '#6EBE64',
};

const buttonColors = {
  'color-btn-primary': colors['color-primary'],
  'color-btn-primary-light': colors[colors['color-primary-light']],
  'color-btn-primary-dark': colors['color-primary-dark'],

  'color-btn-secondary': colors['color-secondary'],
  'color-btn-secondary-light': colors['color-secondary-light'],
  'color-btn-secondary-dark': colors['color-secondary-dark'],

  'color-btn-tertiary': colors['color-quaternary'],
  'color-btn-tertiary-light': colors['color-quaternary-light'],
  'color-btn-tertiary-dark': colors['color-quaternary-dark'],
};

const platformTheme = {
  ...colors,
  ...buttonColors,
};

export default platformTheme;
